import React from 'react'
import { PartialCoverdImage } from 'components/PartialCoverdImage'
import { ImageCredits } from 'components/ImageCredits'
import { Quote } from 'components/Quote'
import { PersonIntroduction } from 'components/PersonIntroduction'

export const Margarita = ({
  size,
  colors
}: {
  size: { width: number; height: number; isMobile: boolean }
  colors: { main: string; sub: string; cover: string }
}) => (
  <div className='ui vertical segment'>
    <div className='ui text container'>
      <div className='ta text'>
        <PersonIntroduction
          name='Margarida Campos'
          sub={
            <>
              50, Sitzwache und Hilfspflegerin,
              <br /> Thalwil, seit 1991 in der Schweiz, Stimmrecht seit 2019
            </>
          }
          img={require('images/margarida_quad.jpg')}
          colors={colors}
        />
        <p>
          «Als ich 2019 das erste Mal abstimmen ging, war ich weder nervös noch
          überglücklich. Ich tat es aber erhobenen Hauptes und dachte: ‹Yes!› Es
          tut immer gut, wenn man ein Wörtchen mitreden kann, gerade, wenn man
          nicht einverstanden ist. Ich finde es gut, wenn ich als einzelne
          Stimme ‹Nein› sagen kann. Natürlich stimme ich nicht immer dagegen.
          Ich bin oft dafür, für das Positive.
        </p>
        <p>
          Ursprünglich kam ich für eine Saison in die Schweiz, drei Monate,
          1991. Und bin geblieben. Ich arbeitete viel. Zuletzt als Sitzwache und
          Hilfspflegerin im Stadtspital Triemli in Zürich. Ich habe nicht viel
          Lohn bekommen, aber den Respekt der Menschen. Darauf bin ich stolz.
        </p>
        <Quote infos={'Margarida Campos'} colors={colors}>
          «Die Frau soll neben ihrem Mann stehen, nicht einmal vor, sondern einfach neben ihm.»
        </Quote>
        <p>
          Plötzlich wurde ich krank. Da begann ich, zu überlegen, ob ich den
          Pass beantragen soll. Ich bin schon lange in der Schweiz, fühle mich
          aber weder als Schweizerin noch als Portugiesin. Mittlerweile
          vielleicht mehr als Schweizerin, nach 30 Jahren hier im Land.
        </p>
        <p>
          Die Sprache war für mich von Anfang an wichtig – um meine Meinung zu
          sagen. Von anderen höre ich, sie hätten keine Zeit gehabt, um die
          Sprache zu lernen. Ich glaube: Viele haben einfach keine Lust oder
          konzentrieren sich vor allem darauf, Geld zu verdienen. Klar ist das
          wichtig. Auch ich habe viel gearbeitet. Und mein Deutsch ist nicht
          perfekt. Aber jeder versteht, was ich meine.
        </p>
        <p>
          Ob Leute ohne Schweizer Pass abstimmen sollten? Ich finde, es steht
          jeder Person frei, sich zu fragen: Was will ich? Wenn jemand den Pass
          möchte, soll er ihn beantragen. Auch ich musste kämpfen, um meine
          politische Stimme zu erhalten – viele Papiere einreichen, viel
          Bürokratie erledigen. Und am Schluss bezahlen.
        </p>
      </div>
    </div>
    <div className='ui container '>
      <PartialCoverdImage
        url={size.isMobile ? 'margarida_hoch.jpg' : 'margarida_quer.jpg'}
        covers={
          size.isMobile
            ? ['bottom left', 'top right']
            : ['bottom right', 'top left']
        }
        colors={colors}
        infos={[
          size.isMobile ? 'bottom left' : 'bottom right',
          <ImageCredits
            noSpace
            text='Margarida Campos sagt offen ihre Meinung, auch wenn sie weiss, dass dies nicht bei allen gut ankommt. Sie sieht sich als Kämpferin.'
            colors={colors}
          />
        ]}
      />
    </div>{' '}
    <div className='ui text container '>
      <div className='ta text'>
        <p>
          Ich finde es gut, dass ich jetzt abstimmen und auch auf diesem Wege
          für meine Anliegen kämpfen kann. Oft dauert es etwas länger, bis es
          eine Lösung gibt. Aber so ist die Demokratie. Ich habe Geduld. Und ich
          bete viel zu Gott. Ich glaube daran, dass auch er das eine oder andere
          richten wird.
        </p>
        <p>
          Vor Abstimmungen und Wahlen verfolge ich TV-Debatten, um mich zu
          informieren. Ich lese auch die offiziellen Broschüren zu den Vorlagen
          und Kandidierenden und diskutiere mit Nachbarinnen und Freundinnen.
          Manchmal folge ich auch meiner Intuition.
        </p>
        <p>
          Ich finde, wir sind bereits vorwärtsgekommen. Wir haben
          Bundesrätinnen, Stadtpräsidentinnen, andere Politikerinnen. Aber noch
          halten einige an einer Mentalität fest, für die ich langsam keine
          Nerven mehr habe.
        </p>
        <p>
          Ich fordere mehr Respekt für uns Frauen und dass wir für die gleiche
          Arbeit gleich bezahlt werden wie Männer. Schluss mit dem Macho-Getue,
          damit, dass der Mann vorne steht und die Frau hinter den Kulissen
          wirken ‹darf›. Das ist erniedrigend. Die Frau soll neben ihrem Mann
          stehen, nicht einmal vor, sondern einfach neben ihm. Ich bin keine
          Feministin, aber ich bin für Gerechtigkeit und Gleichheit. Manchmal
          sage ich zu mir: ‹Sei glücklich, bist du allein!›»
        </p>
      </div>
    </div>
  </div>
)
